<template>
  <section>
    <h2>{{ $t('login.error-title') }}</h2>

    <p class="error-message">{{ errorMessage }}</p>

    <h2>{{ $t('login.contact-label') }}</h2>

    <div class="contact-group">
      <Remixicon name="ri-mail-line" />
      <a class="button-link"
         :href="'mailto:' + $t('ewn.support-email') + '?subject=' + $t('ewn.support-email-subject')">
        {{ $t('ewn.support-email') }}
      </a>
    </div>

    <div class="contact-group">
      <Remixicon name="ri-customer-service-2-line" />
      <a class="button-link" :href="'tel:' + $t('ewn.support-phone')">
        {{ $t('ewn.support-phone') }}
      </a>
    </div>

    <router-link to="/login" class="button-link">
      {{ $t('login.return-button') }}
    </router-link>
  </section>
</template>

<script>
  import { defineComponent } from 'vue';
  import { useI18n } from '@/i18n';
  import Remixicon from '@/modules/icons/components/Remixicon';
  import { useRouter } from '@/router';

  function getErrorMessage (query, i18n) {
    switch (query.code) {
      case 'saml2_provider':
        return i18n.t('saml2.providerError');
      case 'saml2_response':
        // eslint-disable-next-line no-case-declarations
        const key = (query.secondLevel || query.topLevel).replace(/\./g, '-');
        return i18n.t(`saml2.responseError.${key}`, {
          topLevelCode: query.topLevel,
          secondLevelCode: query.secondLevel
        });
      case 'saml2_parse':
        return i18n.t(`saml2.parseError.${query.status}`);
      case 'saml2_auth':
        return i18n.t(`saml2.authError.${query.status}`);
      case 'saml2_logout':
        return i18n.t(`saml2.logoutError.${query.status}`);
      default:
        return i18n.t('login.unexpected-error');
    }
  }

  export default defineComponent({
    components: {
      Remixicon
    },
    setup () {
      const i18n = useI18n();
      const { currentRoute } = useRouter();
      return {
        errorMessage: getErrorMessage(currentRoute.query, i18n)
      };
    }
  });
</script>

<style lang="scss" scoped>
  @use '@/styles/modules/palette';

  h2:first-of-type,
  .error-message {
    color: palette.$status-error-perceptual-color;
  }

  h2 {
    margin-bottom: 16px;
    text-align: center;
  }

  .error-message {
    margin-bottom: 32px;
  }

  .contact-group {
    margin: 0 auto;
    text-align: center;
    margin-bottom: 16px;
  }

  svg {
    display: block;
    width: 32px;
    height: 32px;
    margin: 0 auto;
  }
</style>
